<template>
  <div class="container">
    <canvas ref="canavas" :style="canvasStyle"></canvas>
    <!-- 实时视频 allowClick上下操作栏是否显示-->
    <div v-if="device.serialNumber" class="real-video-box">
      <RealVideo
        :device.sync="device"
        :currentItem="currentItem"
        :deviceName="device.serialNumber"
        :allowClick="true"
        ref="realVideoContr"
        v-drag
      ></RealVideo>
    </div>
  </div>
</template>

<script>
import RealVideo from '@/views/monitor/index/RealVideo.vue'
import { initWss } from '@/common/indoorMap'
import { gethelmet } from '@/api/helmetManage'
import { info } from '@/util/common'
// 画布对象
let canvas = null
// 绘制对象
let ctx = null
// 头盔图片
let helmetImg = new Image()
helmetImg.src = require('@/icon/indoormap/helmet.png')
// 房间图片
let roomImg = new Image()
// websocket对象
let ws = null
// canava上的原点，即x=0,y=0
let origin = { x: 0, y: 0 }
let scale = { x: 0, y: 0 }
// 头盔图片大小
let helmetImgSize = 20
// 滚轮缩放实际倍数
let totalScale = 1
// 拖动相对0，0偏移
let totalOffsetX = 0
let totalOffsetY = 0
export default {
  name: 'IndoorMap',
  data: () => {
    return {
      canavas: null,
      helmets: {},
      canvasStyle: {
        width: 0,
        height: 0,
        cursor: 'default',
      },
      device: {
        serialNumber: null,
        username: null,
      },
      currentItem: {
        deviceName: '',
        specType: 1,
        userId: 0,
        userName: '',
      },
      // 标签绑定头盔
      tagBindsHelmet: {
        '2152': 'HWIH060000010156',
        '22B4': 'HWIH060000011911',
        '1F6F': 'HWIH060000001678',
      },
    }
  },
  components: {
    RealVideo,
  },
  mounted() {
    /**
     * 当前坐标是否悬浮在图标上
     * @param e 鼠标事件
     * @param handle 自定义处理函数
     */
    let hasHoverIcon = (e, handle) => {
      let hoverd = false
      let x = e.offsetX
      let y = e.offsetY
      for (var key in this.helmets) {
        if (
          x / totalScale - totalOffsetX - helmetImgSize < this.helmets[key].x &&
          x / totalScale - totalOffsetX + helmetImgSize > this.helmets[key].x &&
          y / totalScale - totalOffsetY - helmetImgSize < this.helmets[key].y &&
          y / totalScale - totalOffsetY + helmetImgSize > this.helmets[key].y
        ) {
          // console.log(`hover ${key}`)
          hoverd = true
          if (typeof handle === 'function') {
            handle(key)
          }
        }
      }
      return hoverd
    }
    // 重置缩放与原点
    totalScale = 1
    this.scaleChange(1, 0, 0)
    this.sizeChange()
    // console.log(origin, scale, totalScale, totalOffsetX, totalOffsetY)
    window.onresize = () => {
      this.sizeChange()
    }

    canvas = this.$refs.canavas
    ctx = canvas.getContext('2d')

    let pressed = false
    let orgX = 0
    let orgY = 0
    canvas.onmousedown = e => {
      pressed = true
      orgX = e.offsetX
      orgY = e.offsetY
    }

    canvas.onmousemove = e => {
      if (pressed) {
        let offsetX = e.offsetX - orgX
        let offsetY = e.offsetY - orgY
        orgX = e.offsetX
        orgY = e.offsetY
        totalOffsetX += offsetX
        totalOffsetY += offsetY
      }

      if (hasHoverIcon(e)) {
        this.canvasStyle.cursor = 'pointer'
      } else {
        this.canvasStyle.cursor = 'default'
      }
    }

    canvas.onmouseup = () => {
      pressed = false
    }

    canvas.onclick = e => {
      hasHoverIcon(e, tag => {
        if (tag && this.tagBindsHelmet[tag]) {
          if (this.device.serialNumber) {
            info('如需切换用户实时视频，请先关闭当前用户实时视频再重新打开')
          } else {
            gethelmet({ serialNumber: this.tagBindsHelmet[tag] }).then(res => {
              if (res && res.data && res.data.list && res.data.list[0]) {
                let device = res.data.list[0]
                this.device = {
                  serialNumber: device.serialNumber,
                  username: device.userName,
                }
                this.currentItem = {
                  deviceName: device.serialNumber,
                  specType: device.specType,
                  userId: device.userId,
                  userName: device.userName,
                }
              }
            })
          }
        }
      })
    }
    roomImg.src = require('@/icon/indoormap/room.png')
    roomImg.onload = () => {
      setInterval(() => {
        if (ctx) {
          ctx.clearRect(0, 0, 3000, 2000)
          ctx.drawImage(roomImg, totalOffsetX, totalOffsetY, canvas.width, canvas.height)
          for (var key in this.helmets) {
            ctx.drawImage(
              helmetImg,
              totalOffsetX + this.helmets[key].x,
              totalOffsetY + this.helmets[key].y,
              helmetImgSize,
              helmetImgSize
            )
          }
        }
      }, 50)
    }
    initWss(data => {
      // 坐标 校正
      this.helmets[data.tag_id] = {
        x: parseInt(origin.x - data.y * scale.x - helmetImgSize / 2),
        y: parseInt(origin.y - data.x * scale.y - helmetImgSize / 2),
      }
    })
    canvas.onmousewheel = e => {
      let evt = e || window.event
      let x = e.offsetX
      let y = e.offsetY
      evt.preventDefault()
      if (evt.deltaY > 0) {
        totalScale *= 0.9
        this.scaleChange(0.9, (totalOffsetX - x) / 2, (totalOffsetY - y) / 2)
      } else {
        totalScale *= 1.1
        this.scaleChange(1.1, (totalOffsetX - x) / 2, (totalOffsetY - y) / 2)
      }
    }
  },
  methods: {
    // 窗口大小改变会进行自适应，重置canvas高度
    sizeChange() {
      this.$nextTick(() => {
        // canava 宽高
        let canvas = this.$refs.canavas
        var width = canvas.parentElement.scrollWidth
        var height = canvas.parentElement.scrollHeight - 4
        // canava 实际宽高
        this.canvasStyle = {
          width: width + 'px',
          height: height + 'px',
          cursor: 'default',
        }
        canvas.width = width
        canvas.height = height

        // canava原点，头盔的展示依靠该位置计算
        origin = {
          x: parseInt(width * 0.81),
          y: parseInt(height * 1),
        }
        // canava与坐标之间scale
        scale = {
          x: parseInt((width * 0.3) / 10.7),
          y: parseInt((height * 0.2) / 5),
        }
      })
    },
    // 比例尺和偏移计算
    scaleChange(scale, x, y) {
      if (ctx) {
        ctx.scale(scale, scale)
        totalOffsetX = x
        totalOffsetY = y
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.container {
  height: 100%;
}

div {
  text-align: center;
  position: relative;
}

::v-deep .el-dialog__body {
  padding: 0 !important;
}

.real-video-box {
  position: absolute;
  width: 550px;
  height: 300px;
  top: 0;
  right: 0;
}
</style>
